<template>
  <v-col cols="12">
    <v-form ref="tradeNameForm">
      <base-card>
        <v-card-title>
          Impresión de datos en FE de EDN
        </v-card-title>
        <v-card-text>
          <v-row v-if="isAdmin">
            <v-col cols="12" sm="4">
              <v-select
                ref="cliente"
                v-model="data.IdCompania"
                :items="detailClients"
                item-text="text"
                item-value="IdCompania"
                label="Compañia"
                prepend-inner-icon="mdi-sitemap"
                :error="companySelectorError"
                :rules="[validateCompanyField]"
                :error-messages="helperSelectorText"
                @change="handleSelectChange"
                filter
                search-input
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          class="search-field"
                          v-model="search"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="checkCompanyField"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="searchIfIsAdmin">
            <v-col
              cols="12"
              sm="4"
            >
              <v-switch
                v-model="data.configStatus"
                :label="`${data.configStatus ? '[Imprime datos del establecimiento en FE de EDN]' : '[Imprime datos de la compañia en FE de EDN]'}`"
                hide-details
                inset
              />
            </v-col>

               <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="validateConfigData"
              >
                Guardar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-alert
              v-show="successAlert"
              type="success"
              text
            >
              {{ msgSuccessAlert }}
            </v-alert>

            <v-alert
              v-show="errorAlert"
              type="warning"
              text
            >
              {{ msgErrorAlert }}
            </v-alert>
          </v-row>
        </v-card-text>
      </base-card>
    </v-form>
  </v-col>
</template>

<script>

export default {
  name: 'ConfigTradeName',

  data() {
    return {
      data: {
        configStatus: false,
      },
      searchIfIsAdmin: false,
      search: '',
      errorMessages: '',
      formHasErrors: null,
      successAlert: false,
      msgSuccessAlert: '',
      errorAlert: false,
      msgErrorAlert: '',
      formRules: [
        (v) => !!v || 'Este campo es requerido (Solo acepta números)'
      ],
      companySelectorError: false,
      helperSelectorText: '',
      firstTime: true,
    }
  },

  computed: {
    statusResponseUpdateTradeNameConfig() {
      return this.$store.state.tradeName.statusSetTradeNameConfResponse
    },
    statusResponseGetTradeNameConfig() {
      return this.$store.state.tradeName.statusGetTradeNameConfResponse
    },
    detailClients() {
      if (this.isAdmin) {
        return (
          this.$store.state.tradeName.listClients.Mensaje || []
        )
          .filter((compania) => compania.Activo === 1)
          .filter((compania) =>
            compania.NombreCompania.toLowerCase().includes(
              this.search.toLowerCase()
            )
          )
          .map((compania) => ({
            ...compania,
            text: `[${compania.IdCompania}] ${compania.NombreCompania}`,
          }));
      }

      return (this.$store.state.tradeName.listClients.Mensaje || []).filter(
        (compania) =>
          compania.IdCompania ===
          JSON.parse(atob(localStorage.getItem("uid"))).idcompania
      );
    },
  },

  created () {
    this.isAdmin =
      JSON.parse(atob(localStorage.getItem("uid"))).rol === "Administrador" || JSON.parse(atob(localStorage.getItem("uid"))).rol === "AdminI+D" || JSON.parse(atob(localStorage.getItem("uid"))).rol === "Desarrollador"
    if(!this.isAdmin) {
      this.getTradeNameConfig()
      this.searchIfIsAdmin = true
    }
    this.getListClients()
  },

  watch: {
    '$store.state.tradeName.tradeName': {
      handler(data) {
        this.data.configStatus = data.NombreComercial == '1'
      },
      deep: true
    },
    formHasErrors () {
      if (this.formHasErrors === false) {
        this.sendTradeNameConfig()
        this.sendTradeNameConfig()
        this.formHasErrors = null
      }
    },
    statusResponseUpdateTradeNameConfig () {
      if(this.statusResponseUpdateTradeNameConfig === false) {
        this.generateAlertSuccess()
        this.formHasErrors = true
        this.msgSuccessAlert = this.$store.state.tradeName.tradeNameConfigMessage
        this.$store.dispatch('tradeName/setUpdateStatusResponse', null)
      } else if(this.statusResponseUpdateTradeNameConfig === true) {
        this.generateAlertError()
        this.formHasErrors = true
        this.msgSuccessAlert = this.$store.state.tradeName.tradeNameConfigMessage
        this.$store.dispatch('tradeName/setUpdateStatusResponse', null)
      }
    },
    statusResponseGetTradeNameConfig () {
      if(this.statusResponseGetTradeNameConfig === false) {
        this.searchIfIsAdmin = true
        this.generateAlertSuccess()
        this.msgSuccessAlert = this.$store.state.tradeName.tradeNameConfigMessage
        this.$store.dispatch('tradeName/statusGetTradeNameConfResponse', null)
      } else if(this.statusResponseGetTradeNameConfig === true) {
        this.searchIfIsAdmin = true
        this.generateAlertError()
        this.msgSuccessAlert = this.$store.state.tradeName.tradeNameConfigMessage
        this.$store.dispatch('tradeName/statusGetTradeNameConfResponse', null)
      }
    }
  },

  methods: {
    async getListClients () {
      await this.$store.dispatch('tradeName/getListClients')
    },
    async getTradeNameConfig () {
      await this.$store.dispatch('tradeName/getTradeNameConfig', {
        ...this.data
      })
    },
    generateAlertSuccess () {
      this.successAlert = true
      setTimeout(() => {
        this.successAlert = false
      }, 3000)
    },
    generateAlertError () {
      this.errorAlert = true
      setTimeout(() => {
        this.errorAlert = false
      }, 3000)
    },
    validateConfigData () {
      this.formHasErrors = !this.$refs.tradeNameForm.validate();
    },
    sendTradeNameConfig () {
      this.$store.dispatch('tradeName/updateTradeNameConfig', {
        ...this.data
      })
    },
    validateCompanyField(value) {
      if ((!value || value <= 0) && this.firstTime === false) {
        this.companySelectorError = true
        this.helperSelectorText = 'El campo no puede estar vacío.'
        return false
      } else {
        this.companySelectorError = false
        this.helperSelectorText = ''
        return true
      }
    },
    checkCompanyField() {
      this.firstTime = false
      if (this.validateCompanyField(this.data.IdCompania)) {
        this.getTradeNameConfig()
      }
    },
    handleSelectChange (newValue) {
      this.searchIfIsAdmin = false
    }
  }
}

</script>
